import React, { Component } from 'react';
import logo from '../images/logo.png';
import './App.css';
import Routes from '../routes';


class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
        </header>
        <Routes />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js